<template>
  <div>
    <el-row>
      <el-col :span="6" style="max-width: 160px">
        <label
          class="has-text-grey"
          style="vertical-align: middle; margin-left: 0.5em; margin-bottom: 2em; font-size: 14px"
        >
          {{ setting.label || name }}
          <Tooltip :label="setting.label || name" :content="setting.detail" />
        </label>
      </el-col>
      <el-col :span="22" style="max-width: 540px; margin-left: 0.5em">
        <JSONEditor ref="jsonEditor" v-model="value[name]" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
/**
 * Json SmartField - Renders a JSON editor for object/array configuration values.
 *
 * @component
 * @description Displays a rich JSON editor with syntax highlighting, validation, and formatting.
 * Uses the JSONEditor component to provide a developer-friendly interface for editing
 * complex JSON structures.
 *
 * @prop {Object} value - Parent object containing the setting value
 * @prop {Object} setting - Field configuration object
 * @prop {string} [setting.label] - Display label for the JSON editor (defaults to name)
 * @prop {string} [setting.detail] - Tooltip text explaining the setting
 * @prop {Object|Array} [setting.default] - Default JSON value if not set
 * @prop {string} name - Property key in the value object
 *
 * @example
 * <Json
 *   :value="config"
 *   :setting="{
 *     label: 'API Response',
 *     detail: 'Configure API response mapping',
 *     default: { status: 'success', data: [] }
 *   }"
 *   name="apiResponse"
 * />
 */
import JSONEditor from "@/components/JSONEditor";
import Tooltip from "../Tooltip.vue";
export default {
  props: ["value", "setting", "name"],
  components: {
    JSONEditor,
    Tooltip,
  },
  mounted() {
    if (this.value[this.name] == null) {
      if (this.setting.default != null) {
        this.$set(this.value, this.name, this.setting.default);
      } else {
        this.$set(this.value, this.name, null);
      }
    }
  },
};
</script>
